<p>
  This site is still under construction.  Please feel free to look around and sign up, but understand it is not yet fully functional.
</p>

<button mat-raised-button color="primary" (click)="closeUnderConstruction()">Close</button>
